import React from 'react';
import { connect } from "react-redux";
import AppraiserSignature from "components/Appraiser/AppraiserSignature.js";
export default connect(state => ({ caseForms: state.caseForms.caseFormsList }))(() => {
  return (
    <>
      <AppraiserSignature appraiserNumber={376986} />
    </>
  );
});